import type { ReactNode } from "react";
import { cn } from "../utils";

function ImageBadge({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "absolute right-2 bottom-2 rounded bg-black/60 px-2 py-0.5 text-xs font-medium text-white",
        className,
      )}
    >
      {children}
    </span>
  );
}

export default ImageBadge;
